import { Component } from "@angular/core";


@Component({
  selector: "app-typing-indicator",
  standalone: true,
  imports: [],
  template: `
    <div class="flex justify-start mb-6">
      <div class="flex gap-3 max-w-[85%]">
        <div
          class="w-8 h-8 bg-gradient-to-br from-light-primary to-light-primary-variant dark:from-dark-primary to-dark-primary-variant rounded-full flex items-center justify-center flex-shrink-0 mt-1"
        >
          <span class="text-white text-xs font-semibold">AI</span>
        </div>
        <div class="message-bubble message-bot">
          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class TypingIndicatorComponent {}
